// extracted by mini-css-extract-plugin
module.exports = {"container":"RelatedProducts_container___2lNL","title":"RelatedProducts_title__gfONz","relatedProductsGrid":"RelatedProducts_relatedProductsGrid__zc2eF"};